import { useMemo } from "react";

export function DeliverySparkline({ logs }) {
  const data = useMemo(() => {
    const days = 30;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bucket = Array.from({ length: days }).map((_, i) => {
      const d = new Date(today);
      d.setDate(d.getDate() - (days - 1 - i));
      return { date: d.toISOString().slice(0, 10), delivered: 0, bounced: 0, sent: 0, failed: 0 };
    });
    const index = new Map(bucket.map((b, i) => [b.date, i]));
    (logs || []).forEach((l) => {
      const d = (l.createdAt || "").slice(0, 10);
      const i = index.get(d);
      if (i === undefined) return;
      if (l.status === "delivered" || l.status === "opened" || l.status === "clicked") bucket[i].delivered += 1;
      else if (l.status === "bounced" || l.status === "complained") bucket[i].bounced += 1;
      else if (l.status === "failed") bucket[i].failed += 1;
      else if (l.status === "sent") bucket[i].sent += 1;
    });
    return bucket;
  }, [logs]);
  const total = data.reduce((s, b) => s + b.delivered + b.bounced + b.sent + b.failed, 0);
  if (total === 0) return <div className="delivery-sparkline empty" data-testid="delivery-sparkline-empty"><span className="muted">Son 30 gün için gönderim verisi yok</span></div>;
  const totals = data.reduce((acc, b) => ({ delivered: acc.delivered + b.delivered, bounced: acc.bounced + b.bounced, sent: acc.sent + b.sent, failed: acc.failed + b.failed }), { delivered: 0, bounced: 0, sent: 0, failed: 0 });
  const maxDay = Math.max(1, ...data.map(b => b.delivered + b.bounced + b.sent + b.failed));
  const W = 320, H = 56, pad = 2;
  const barW = (W - pad * 2) / data.length;
  const deliveryRate = totals.delivered + totals.bounced + totals.failed > 0
    ? Math.round(100 * totals.delivered / (totals.delivered + totals.bounced + totals.failed))
    : null;
  return (
    <div className="delivery-sparkline" data-testid="delivery-sparkline">
      <div className="sparkline-head">
        <div>
          <strong data-testid="sparkline-total">{total} gönderim</strong>
          <span className="muted"> · son 30 gün</span>
        </div>
        <div className="sparkline-legend">
          <span><i style={{ background: "#10b981" }} /> {totals.delivered} teslim</span>
          <span><i style={{ background: "#3b82f6" }} /> {totals.sent} gönderildi</span>
          <span><i style={{ background: "#f59e0b" }} /> {totals.bounced} bounce</span>
          <span><i style={{ background: "#ef4444" }} /> {totals.failed} hata</span>
          {deliveryRate !== null && <span className="delivery-rate" data-testid="delivery-rate">%{deliveryRate} teslim oranı</span>}
        </div>
      </div>
      <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="sparkline-svg" preserveAspectRatio="none">
        {data.map((b, i) => {
          const sum = b.delivered + b.bounced + b.sent + b.failed;
          if (sum === 0) return null;
          const x = pad + i * barW + 1;
          const totalH = (sum / maxDay) * (H - 4);
          let y = H - 2 - totalH;
          const segs = [
            { v: b.delivered, c: "#10b981" },
            { v: b.sent, c: "#3b82f6" },
            { v: b.bounced, c: "#f59e0b" },
            { v: b.failed, c: "#ef4444" },
          ];
          return (
            <g key={i}>
              <title>{`${b.date}: ${b.delivered} teslim, ${b.sent} gönderildi, ${b.bounced} bounce, ${b.failed} hata`}</title>
              {segs.map((s, si) => {
                if (!s.v) return null;
                const h = (s.v / sum) * totalH;
                const r = <rect key={si} x={x} y={y} width={Math.max(1, barW - 2)} height={h} fill={s.c} rx={1} />;
                y += h;
                return r;
              })}
            </g>
          );
        })}
      </svg>
    </div>
  );
}
